t = require('app/scripts/views/internal/teacup-with-helpers')('member_large_avatar')

module.exports = t.renderable ({ avatarUrl, viewTitle, avatarSource }) ->
  title = viewTitle
  className = ''
  if avatarSource == 'atlassianAccount'
    className = "pop-over-atlassian-account-avatar"
  t.img { src: [avatarUrl, 'original.png'].join('/'), class: className, alt: title, title }
